type Env = 'development' | 'production' | 'staging'

export const appConfig = {
  brand: process.env.REACT_APP_X_BRAND || 'gameskinx',
  apiBaseUrl: process.env.REACT_APP_API_URL || 'https://api-dev.gameskinx.com/api/v2',
  appEnv: (process.env.REACT_APP_ENV || process.env.NODE_ENV || 'production') as Env,
  pciProxyMerchantId: process.env.REACT_APP_PCI_PROXY_MERCHANT_ID || '1110014653',
}

export default appConfig
